
export default {
  name: 'Submit',
  props: {
    buttonText: {
      type: String,
      required: true
    },
    withoutArrow: {
      type: Boolean,
      required: false,
      default: false
    },
    mailSuccess: {
      type: Boolean,
      required: false,
      default: false
    },
    successMessage: {
      type: String,
      required: false,
      default: 'Success!'
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
